import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Utils
import { getCustomerStatus } from 'common/utils/customerValidation'

// Views
import { Container } from 'views/components'

import { App, Header, Sidebar, Content, PageWrapper, BlockchainAnalyticsSubHeader, NoAccess } from 'views/layouts'

import {
  TransactionsTable,
  TransactionsSearchBar,
  DemoTransactionSearchBar,
  DemoTransactionsTable,
} from 'views/containers'

// Map Redux Props
const mapStateToProps = ({ filters, ui }) => ({ filters, ui })
const mapDispatchToProps = actions

function Transactions() {
  const [csi] = useState(getCustomerStatus())
  return (
    <App>
      <Sidebar />
      <Header subHeader={<BlockchainAnalyticsSubHeader />} pageTitle="Blockchain Analytics" />
      <NoAccess />
      {/* <Content>
        <PageWrapper>
          <Container>
            {csi === 1 && <TransactionsSearchBar />}
            {csi === 1 && <TransactionsTable />}

            {csi !== 1 && <DemoTransactionSearchBar />}
            {csi !== 1 && <DemoTransactionsTable />}
          </Container>
        </PageWrapper>
      </Content> */}
    </App>
  )
}

// Default Props
Transactions.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
Transactions.propTypes = {
  actions: PropTypes.shape({
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    showAlert: PropTypes.func,
  }),
  filters: PropTypes.shape({
    whitelistingFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(Transactions)
